import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { ApiClientService } from './../../../../services/api-client.service';
import { ConstantsService } from './../../../../services/constants.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

declare const $: any;
declare const toastr: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'incident-reports-comments',
    templateUrl: './incident-reports-comments.component.html',
    styleUrls: ['./incident-reports-comments.component.scss']
})

export class IncidentReportsCommentsComponent implements OnInit, OnDestroy { 
    
    private ngUnsubscribe = new Subject();
    
    @Input() selectedItem;
    @Input() commentsLoading;
    @Input() commentsListLoaded;
    @Output() updateView: EventEmitter<any> = new EventEmitter();

    details = '';
    disabledEntrySubmit = false;
    order = 'desc';
    entryTypedValue = false;
    
    constructor(public api: ApiClientService) { }
    
    ngOnInit() { 
        this.commentsListLoaded
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
                this.sortEntries(this.order);
            });
    }
    
    addEntry() {
        if (!this.details) {
            toastr.warning('Details should not be blank.');
            return;
        }

        const data = {
            incidentReport:     this.selectedItem.id,
            details:          this.details
        };

        this.disabledEntrySubmit = true;

        this.api.post('domainIncidentReports', '/v1/comment.json', data).subscribe(
            () => {
                this.details = '';
                this.entryTyped(false);
                this.disabledEntrySubmit = false;
                this.updateView.emit('Comment successfully created');
            },
            error => {
                this.disabledEntrySubmit = false;
                this.api.errorHandler(error, 'Create comment failed');
            }
        );
    }

    entryTyped(value) {
        this.entryTypedValue = value;
    }
    
    noEntriesEdited() {
        if(this.selectedItem.entries.length > 0) {
            let edited = true;
            this.selectedItem.entries.forEach((entry, index) => {
                if($('#entry' + index)[0] && entry != $('#entry' + index)[0].value)
                    edited = false;
            });
            return edited;
        } else
            return true;
    }

    sortEntries(order) {
        this.order = order;
        this.selectedItem.entries.sort((a: any, b: any) => {
            if (new Date(a.createdAt) < new Date(b.createdAt))
                return this.order == 'desc' ? 1 : -1;
            else if (new Date(a.createdAt) > new Date(b.createdAt))
                return this.order == 'desc' ? -1 : 1;
            else
                return 0;
        });
    }

    removeEntry(index) {
        swal(ConstantsService.getSwalConfig('Delete Comment', 'Are you sure you want to delete comment?'),
            () => {
                if (!this.disabledEntrySubmit) {
                    this.disabledEntrySubmit = true;
                    const url = `/v1/comment/${this.selectedItem.entries[index].id}.json`;
                    this.api.remove('domainIncidentReports', url).subscribe(
                        () => {
                            this.disabledEntrySubmit = false;
                            this.updateView.emit('Comment was deleted successfully');
                        },
                        error => {
                            this.disabledEntrySubmit = false;
                            this.api.errorHandler(error, 'Failed to delete comment');
                        }
                    );
                }
            }
        );
    }

    editEntry(index) {
        if (!$('#entry' + index).val()) {
            toastr.warning('Entry should not be blank.');
            return;
        }

        const data = {
            incidentReport:     this.selectedItem.id,
            details:          $('#entry' + index).val()
        };

        this.disabledEntrySubmit = true;

        const url = `/v1/comment/${this.selectedItem.entries[index].id}.json`

        this.api.patch('domainIncidentReports', url, data).subscribe(
            () => {
                this.disabledEntrySubmit = false;
                this.updateView.emit('Comment successfully created');
            },
            error => {
                this.disabledEntrySubmit = false;
                this.api.errorHandler(error, 'Create comment failed');
            }
        );
    }

    closeEntryEditing(entry, index) {
        if(entry.details == $('#entry' + index)[0].value) {
            if (this.entryTypedValue && !this.details)
                this.entryTypedValue = false;
            entry.editMode = false;
        } else {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.entryTypedValue = false;
                    entry.editMode = false;
                }
            );
        }
    }
    
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}


// WEBPACK FOOTER //
// /app/src/app/views/incident-reports/incident-report-detailed-view/incident-reports-comments/incident-reports-comments.component.ts